import "./CompanyPartner.module.css";
import Header from "@/reusable_sections/Header";
import PartnerIntroduction from "./sections/PartnerIntroduction";
import StrategicPartners from "./sections/StrategicPartners";
import ConnectWithUs from "./sections/ConnectWithUs";
import Footer from "@/reusable_sections/Footer";
export default function CompanyPartnerPage() {
  return <div>
      <Header />
      <PartnerIntroduction />
      <StrategicPartners />
      <ConnectWithUs />
      <Footer />
    </div>;
}